import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';
import { TokenStorageService } from 'src/app/authentication/storages/token-storage.service';
import { hasRouteAccess } from '../helpers/route-permissions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private tokenStorageService : TokenStorageService,
    private permissionStorage : PermissionStorageService
    ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!this.tokenStorageService.getToken()){
      return this.router.createUrlTree(["/auth"]);
    }

    // The same rule the navigation menu uses to show or hide its items - see hasRouteAccess.
    // routeConfig carries the declared data and the child routes a hub derives its access from.
    return hasRouteAccess(
      route.routeConfig ?? { data: route.data },
      this.permissionStorage.getPermissions() ?? []);
  }

}
